import { ProjectSearch } from './../common-theme/models/project-search.model';
import { Project } from './../common-theme/models/project.model';
import { Subscription } from 'rxjs/Subscription';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as Raven from 'raven-js';
import { ProjectService } from '../common-theme/api/project.service';
import { AgencyService } from '../common-theme/api/agency.service';

@Component({
  selector: 'app-portfolio',
  templateUrl: './../houses/houses.component.html',
  styleUrls: ['./../houses/houses.component.scss']
})

export class PortfolioComponent implements OnInit, OnDestroy {
  pageHeight: number;
  @ViewChild('listSection') listSection: ElementRef;
  projects: Project[] = [];
  projectSearch: ProjectSearch = new ProjectSearch();
  subscription: Subscription = new Subscription();
  timeoutId: any = null;
  apiLoading: boolean = false;
  page: number = 1;
  endOfList: boolean = false;
  type: string = 'project';

  constructor(
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private router: Router,
    public agencyService: AgencyService,
    @Inject('WINDOW') private window: any,
    @Inject('SCREEN') private screen: any
  ) { }

  ngOnInit(): void {
    this.route.data.forEach((data: any) => {
      this.projects = data.projects;
      this.removeSomeProjects();
    });

    this.subscription = this.route.queryParams.subscribe(params => {
      this.projectSearch = this.projectService.decodeUrlParams(params);
      this.refreshProjects();
    });

    if (this.screen) {
      this.pageHeight = this.screen.height - 528;
    }

    if (this.window) {
      this.window.addEventListener('scroll', this.onScroll());
    }
  }

  filterProjects(status: string): void {
    this.projectSearch.sale_status = status;
    this.search();
  }

  search(): void {
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(
      () => {
        for (const field in this.projectSearch)
          if (
            this.projectSearch[field] === null
            || this.projectSearch[field] === undefined
          )
            delete this.projectSearch[field];
        if (this.window) {
          this.router.navigate(
            [this.window.location.pathname],
            {
              queryParams: this.projectSearch
            }
          );
        }
      },
      200
    );
  }

  refreshProjects(): void {
    this.page = 1;
    this.projects = [];
    this.apiLoading = false;
    this.endOfList = false;

    this.addProjects();
  }

  addProjects(): void {
    if (this.apiLoading) {
      this.apiLoading = false;
      return;
    }

    this.apiLoading = true;

    const currentPage = this.page++;

    Raven.captureBreadcrumb({
      message: 'addClients, page: ' + currentPage,
      category: 'projects infinite scroll'
    });

    this.projectService.getProjects(this.projectSearch, currentPage)
      .then(projects => {
        this.apiLoading = false;

        Raven.captureBreadcrumb({
          message: 'getProjects API resonse, page: ' + currentPage,
          category: 'projects infinite scroll'
        });

        if (currentPage === 1) {
          if (this.projects.length) {
            Raven.captureMessage(
              'Projects list error: possbile duplication detected',
              { level: 'warning' }
            );
          }
          this.projects = projects;
        } else {
          this.projects = this.projects.concat(projects);
        }

        if (this.projectSearch.sale_status !== 'sold_out')
          this.removeSomeProjects();

        if (projects.length < 15) {
          this.endOfList = true;
          return;
        }
      });
  }

  onScroll(): void {
    if (this.window) {
      if (!this.endOfList && this.listSection.nativeElement.getBoundingClientRect().bottom - this.window.innerHeight < 0) {
        this.addProjects();
      }
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    clearTimeout(this.timeoutId);
  }

  removeSomeProjects(): void {
    this.projects = this.projects.filter(project =>
      project.id !== 39 && project.id !== 40 && project.id !== 42
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/portfolio/portfolio.component.ts